import { useCallback, useState } from "react"

function useForceUpdate() {
  const [, setState] = useState<object>()

  const forceUpdate = useCallback(() => {
    setState({})
  }, [])

  return forceUpdate
}

export default useForceUpdate
